export default __webpack_public_path__ + "static/media/i_success.e0776172.svg";